module.exports = __webpack_public_path__ + "img/Conceptos.4160ad1f.png";